export const replaceTreeNodeChildren = (treeData, key, children) => treeData.map(node => {
    if (String(node.key) === String(key)) return {...node, children}
    if (!node.children) return node

    const nextChildren = replaceTreeNodeChildren(node.children, key, children)
    return nextChildren === node.children ? node : {...node, children: nextChildren}
})
